import styles from '../styles/product.module.css'
import ProductCard from "../components/ProductCard";

import { getProducts } from '../lib/shopify';
import { useEffect, useState } from 'react';

const PAGE_DATA = {
    title: "Our Collection",
    intro: "Every piece is custom made to order using sustainably sourced hardwoods. Browse our full collection below.",
};


const Products = () => {
    const [products, setProducts] = useState([]);

    const [filter, setFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');

    const start = performance.now();

    const filteredProducts = products.filter(product =>
        filter === '' || product.type === filter
    );

    const searchedProducts = filteredProducts.filter(product =>
        product.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const end = performance.now();

    if (process.env.NODE_ENV === 'development') {
        console.log(`Filter + search took ${(end - start).toFixed(2)} ms`);
    }

    const fetchProducts = async () => {
        try {
            const data = await getProducts();
            setProducts(data);
        } catch (error) {
            console.error('Error fetching products', error);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <div className={styles.main}>
            <div className={styles.productlanding}>
                <div className={styles.productsnip}>
                    <div className={styles.snipinfo}>
                        <div className={styles.title1}>
                            <h1>
                                {PAGE_DATA.title}
                            </h1>
                        </div>
                        <div className={styles.paragragh}>
                            <p>
                               {PAGE_DATA.intro}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.mainproductcontainer}>
                <div className={styles.filterSearch}>
                    <div className={styles.typegroup}>
                        {[...new Set(products.map(product => product.type).filter(Boolean))].map((type) => (
                            <button
                                key={type}
                                value={type}
                                onClick={() => setFilter(prev => (prev === type ? '' : type))}
                                className={filter === type ? styles.filterActive : ''}
                            >{type}</button>
                        ))}
                    </div>

                    <div className={styles.search}>
                        <input
                            type='text'
                            value={searchTerm}
                            placeholder='Search for product'
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <div className={styles.productcontainer}>
                   {searchedProducts.map(product => <ProductCard product={product} key={product.id}/>)}
                </div>
            </div>
        </div>
    )
}

export default Products